import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { OrderFormComponent } from './components/order-form/order-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ProfileComponent } from './components/profile/profile.component';
import { DocumentationComponent } from './components/documentation/documentation.component';
import { AdminModule } from './components/admin/admin.module';
import { HistoryModule } from './components/history/history.module';
import { CurrencyInputDirective } from './utils/currency-formatter';
import { UserIdInterceptor } from './services/auth/user-id.interceptor';
import { AuthService } from './services/auth/auth.service';
import { SparePartsService } from './services/spareParts/spare-parts.service';
import { OrdersService } from './services/orders/orders.service';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    OrderFormComponent,
    HeaderComponent,
    LoginComponent,
    RegisterComponent,
    ProfileComponent,
    DocumentationComponent,
    CurrencyInputDirective
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    AdminModule,
    HistoryModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserIdInterceptor,
      multi: true
    },
    AuthService,
    SparePartsService,
    OrdersService,
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
